import React from 'react'

import ChatWindowV2 from '../../../../components/organisms/ChatWindowV2'

import { useAppDispatch } from '../../../../hooks/redux'
import { MobileScreen, setMobileScreen } from '../../../../slices/convo'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useSocket } from '../../../../providers/SocketProvider'

interface MobileConversationProps {}

const MobileConversation: React.FC<MobileConversationProps> = () => {
  const dispatch = useAppDispatch()

  const { id: selectedConversation } = useQueueState()
  const {
    api: { endSessions }
  } = useSocket()

  // Ends the current session
  const handleEndConversation = React.useCallback(() => {
    endSessions([selectedConversation])
  }, [endSessions, selectedConversation])

  if (!selectedConversation) {
    dispatch(setMobileScreen(MobileScreen.Queue))
  }

  return <ChatWindowV2 isDirect={false} endSession={handleEndConversation} />
}

export default MobileConversation
